/**
 * @file チェックボックスをすべてチェック状態にする
 */
'use strict'

/**
 * @classname CheckAllCheckbox
 * @classdesc チェックボックスをすべてチェック状態にする
 */
export default class CheckAllCheckbox {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.check-all-checkbox')
	 */
	constructor($e) {
		console.log('CheckAllCheckbox.constructor')
		this._$e = $e
		this._$target = $(this._$e.data('target'))
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof CheckAllCheckbox
	 * @return {undefined}
	 */
	onClick() {
		console.log('CheckAllCheckbox.onClick')
		if (this._$e.prop('checked')) {
			this._$e.removeClass('is-invalid')
			this._$target.removeClass('is-invalid')
		}
		this._$e.closest('.form-group').find('.error-tip').removeClass('show')
		this._$target.each((_, e) => $(e).prop('checked', this._$e.prop('checked')))
	}
}
